(ns ui.view.list-opensearch.sub
  (:require-macros [ui.subs.macros :refer [<-1]])
  (:require
   [re-frame.core :as rf]
   [ui.view.list-opensearch.model :as model]))

(rf/reg-sub
 ::list-state
 (fn [db [_ list-id]]
   (get-in db (model/list-path list-id))))

(rf/reg-sub
 ::config
 (<-1 ::list-state)
 (fn [list-state _]
   (get list-state model/config-key)))

(rf/reg-sub
 ::card-config
 (<-1 ::list-state)
 (fn [list-state _]
   (get-in list-state [model/compiled-config-key :card-config])))

(rf/reg-sub
 ::grouped?
 (<-1 ::config)
 (fn [config _]
   (some? (:group-by-field config))))

(rf/reg-sub
 ::items
 (<-1 ::list-state)
 (fn [list-state _]
   (vec (or (get list-state model/items-key) []))))

(rf/reg-sub
 ::status
 (<-1 ::list-state)
 (fn [list-state _]
   (get list-state model/status-key :uninitialized)))

(rf/reg-sub
 ::error
 (<-1 ::list-state)
 (fn [list-state _]
   (get list-state model/error-key)))

(rf/reg-sub
 ::total
 (<-1 ::list-state)
 (fn [list-state _]
   (or (get list-state model/total-key) 0)))

(rf/reg-sub
 ::next-offset
 (<-1 ::list-state)
 (fn [list-state _]
   (get list-state model/next-offset-key 0)))

(rf/reg-sub
 ::has-more?
 (<-1 ::list-state)
 (fn [list-state _]
   (boolean (get list-state model/has-more-key false))))

(rf/reg-sub
 ::groups
 (<-1 ::list-state)
 (fn [list-state _]
   (get list-state model/groups-key {:status :idle
                                     :order []
                                     :by-value {}})))

(rf/reg-sub
 ::group-order
 (<-1 ::groups)
 (fn [groups _]
   (vec (or (:order groups) []))))

(rf/reg-sub
 ::group-by-value
 (<-1 ::groups)
 (fn [groups _]
   (or (:by-value groups) {})))

(rf/reg-sub
 ::group-state
 (<-1 ::list-state)
 (fn [list-state [_ _list-id group-value]]
   (get-in list-state [model/items-by-group-key group-value]
           {:status :idle
            :error nil
            :items []
            :next-offset nil
            :total nil
            :has-more? true})))
